(function () {
  function syncInertState(bar) {
    Array.from(bar.children).forEach(function (item) {
      if (item.getAttribute('aria-hidden') === 'true') {
        item.setAttribute('inert', '');
      } else {
        item.removeAttribute('inert');
      }
    });
  }

  function observeAriaHidden(bar) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName !== 'aria-hidden') return;
        var item = mutation.target;
        if (item.getAttribute('aria-hidden') === 'true') {
          item.setAttribute('inert', '');
        } else {
          item.removeAttribute('inert');
        }
      });
    });

    Array.from(bar.children).forEach(function (item) {
      observer.observe(item, { attributes: true, attributeFilter: ['aria-hidden'] });
    });
  }

  function initBar(bar) {
    if (bar.dataset.inertBound) return;
    bar.dataset.inertBound = 'true';

    // Sync inert with whatever aria-hidden state exists right now
    syncInertState(bar);

    // Keep inert in sync going forward, no matter what sets aria-hidden
    observeAriaHidden(bar);

    // theme.js's AnnouncementBar dispatches this on every Flickity change,
    // but never updates aria-hidden itself — so we do it here
    bar.addEventListener('slider:change', function (event) {
      var currentPage = event.detail.currentPage;
      Array.from(bar.children).forEach(function (item, index) {
        item.setAttribute('aria-hidden', index === currentPage ? 'false' : 'true');
      });
    });
  }

  function initAll() {
    document.querySelectorAll('announcement-bar').forEach(initBar);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  // Handle Shopify theme editor re-renders (section reloads on setting change)
  document.addEventListener('shopify:section:load', function (event) {
    var bar = event.target.querySelector('announcement-bar');
    if (bar) initBar(bar);
  });
})();